<progress-bar>
    <div>
        <div class="bg-red-500 hidden"></div>
        <div class="bg-yellow-500 hidden"></div>
        <div class="bg-green-500 hidden"></div>
        <div class="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
            <div class="h-full transition-all duration-300 bg-{ state.color }-500" style="width: {
                     state.value
                 }
                 %;"></div>
        </div>
    </div>

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {

            onBeforeMount(props) {
                let progress = props.progress ? props.progress * 100 : 0
                this.state = {
                    value: progress,
                    color: "gray"
                }
                eventBus.on(EVENTS.INPUT.UPDATE, this.handleUpdateProgress)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.INPUT.UPDATE, this.handleUpdateProgress)
            },

            handleUpdateProgress(e) {
                if (e.ckey === this.props.ckey) {
                    let value = e.value * 100
                    if (value > 100) {
                        value = 100
                    }
                    let color = ''
                    if (value < 50) {
                        color = 'green'
                    } else if (value < 90) {
                        color = 'yellow'
                    } else {
                        color = 'red'
                    }
                    this.update({
                        value: value,
                        color: color
                    })
                }
            }
        }
    </script>
</progress-bar>
